import { useLang } from "../context/LangContext";
import { useTranslation } from "react-i18next";
import { useCategories } from "./useApi";

export const useServicesList = () => {
  const { data: categories } = useCategories();

  if (!Array.isArray(categories)) {
    return []; // Return empty array if categories is not available yet
  }

  return categories.map((category, index) => ({
    Id: category._id || `0${index + 1}`,
    icon: category.icon || "default-icon.png",
    title: category.name?.en || "Service Name",
    titleAr: category.name?.ar || "اسم الخدمة",
    description: category.description?.en || "No description available.",
    descriptionAr: category.description?.ar || "وصف غير متوفر",
    image: category.image,
    video: category.video || null,
  }));
};

const Services = () => {
  const { lang } = useLang();
  const { t } = useTranslation();

  const { data: categories } = useCategories();

  if (!Array.isArray(categories)) {
    return <p>{t("loading")}</p>; // Handle loading state
  }

  const servicesList = categories.map((category, index) => ({
    Id: category._id || `0${index + 1}`,
    icon: category.icon || "default-icon.png",
    title: category.name?.en || "Service Name",
    titleAr: category.name?.ar || "اسم الخدمة",
    description: category.description?.en || "No description available.",
    descriptionAr: category.description?.ar || "وصف غير متوفر",
    image: category.image,
    video: category.video || null,
  }));
  return (
    <div className="row">
      {servicesList.map((service, index) => (
        <div className="col-xl-4 col-lg-6 col-md-6 col-12" key={index}>
          <div className="service-card">
            <div className="top-number">
              <span>{index + 1}</span>
            </div>
            <div className="icon">
              <img src={service.icon} alt="service" />
            </div>
            <div className="text">
              <h2 className="main-title">
                {lang === "ar" ? service.titleAr : service.title}
              </h2>
              <p>
                {lang === "ar" ? service.descriptionAr : service.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;
